import { ExtranetContainer } from '@pharmac-extranet/shared'
import { PharmacLoadingDots } from '@pharmac/ui'
import { NavigationBar } from '../navigation'

export const ExtranetLoading = () => {
  return (
    <>
      <NavigationBar />
      <ExtranetContainer
        flexRow
        justifyCenter
        marginLargeTop
      >
        <PharmacLoadingDots />
      </ExtranetContainer>
    </>
  )
}
